import { Component } from '@angular/core';

@Component({
  selector: 'vtr-widget-offline-tip',
  templateUrl: './widget-offline-tip.component.html',
  styleUrls: ['./widget-offline-tip.component.scss']
})
export class WidgetOfflineTipComponent {

}
